import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { services } from '../data/mock';
import { Brain, MessageSquare, Bot, Database, Code, Server, Calendar } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  brain: Brain,
  'message-square': MessageSquare,
  bot: Bot,
  database: Database,
  code: Code,
  server: Server,
  calendar: Calendar
};

const Services = () => {
  const { language, t } = useLanguage();

  return (
    <section id="services" className="py-24 bg-transparent">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4">
            {t.services.title}
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-xl hover:shadow-cyan-500/10 transition-all duration-300 hover:-translate-y-2 border-cyan-500/20 bg-slate-900/60 backdrop-blur-sm"
              >
                <CardContent className="p-8">
                  <div className="mb-6">
                    <div className="w-14 h-14 bg-gradient-to-br from-cyan-400 to-teal-500 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-cyan-500/30">
                      <IconComponent className="w-7 h-7 text-slate-950" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-slate-100 mb-3">
                    {language === 'it' ? service.title : service.titleEn}
                  </h3>
                  <p className="text-slate-300 leading-relaxed">
                    {language === 'it' ? service.description : service.descriptionEn}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
